import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'

export default function About() {
  const blocks = useBlockRenderer('about') as Block[]
  return <BlockRenderer blocks={blocks} />
}
